import React from 'react';
import { motion } from 'framer-motion';

export default function OurStorySection() {
  return (
    <motion.section
      className="bg-white py-16 md:py-20 font-sans"
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl">
          <h2
            className="text-3xl md:text-4xl font-bold text-neutral-900 mb-6"
            style={{ fontFamily: 'Inter, sans-serif' }}
          >
            Our story
          </h2>

          <p className="text-base md:text-lg leading-relaxed text-neutral-800 mb-6">
            We started Lincoln AIM to connect great companies with game-changing talent and build partnerships that last.
            Today, from Dubai, London, and New York, our 30+ strong team operates globally across the UK, US, and MENA.
          </p>

          <p className="text-base md:text-lg leading-relaxed text-neutral-800">
            We deliver fast, data-driven recruitment with the market insight, speed, and precision needed by startups,
            financial institutions, and leading technology firms.
          </p>
        </div>
      </div>
    </motion.section>
  );
}
